import { Application } from '@hotwired/stimulus'

window.Stimulus = Application.start()

import controllers from './controllers/**/*.js'
Object.entries(controllers).forEach(([filename, controller]) => {
  if (filename.includes('_controller.') || filename.includes('-controller.')) {
    const identifier = filename
      .replace('./controllers/', '')
      .replace(/[_-]controller\..*$/, '')
      .replaceAll('_', '-')
      .replaceAll('/', '--')

    Stimulus.register(identifier, controller.default)
  }
})
